import { render, staticRenderFns } from "./genealogy.vue?vue&type=template&id=579eaa60&scoped=true"
import script from "./genealogy.vue?vue&type=script&lang=js"
export * from "./genealogy.vue?vue&type=script&lang=js"
import style0 from "./genealogy.vue?vue&type=style&index=0&id=579eaa60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579eaa60",
  null
  
)

export default component.exports